import { compose } from 'react-apollo';
import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';

import AuthForm from './AuthForm.js';

export default compose(

  graphql(gql`
    mutation loginUser(
      $username: String!,
      $password: String!,
    ) {
      loginUser(
        auth: {
          username: $username,
          password: $password,
        }
      ) {
        authorized
      }
    }
  `, {
    name:'loginUser'
  }),

)(AuthForm);